import { useState } from "react";
import { changeStudentMobileNumberAPI, updateStudentAPI } from "../../services/portal/admin/studentService";
import {
  showErrorToastMsg,
  showSuccessToastMsg,
} from "../../utility/ToastMessage";

const StudentContactNumberManage = ({ student }) => {
  const [changingMobile, setChangingMobile] = useState(false);
  const [changeMobileData, setChangeMobileData] = useState({
    mobileNo: "",
    confirmMobileNo: "",
  });

  const handleSubmitChangeMobile = async (e) => {
    e.preventDefault();

    if (!changeMobileData.mobileNo.trim()) {
      showErrorToastMsg("Please enter mobile number");
      return;
    }

    if (!/^[0-9+\-\s()]+$/.test(changeMobileData.mobileNo)) {
      showErrorToastMsg("Please enter a valid mobile number");
      return;
    }

    if (changeMobileData.mobileNo !== changeMobileData.confirmMobileNo) {
      showErrorToastMsg("Mobile numbers do not match");
      return;
    }

    setChangingMobile(true);

    try {
      const params = {
        userId: student.UserId,
        mobileNo: changeMobileData.mobileNo.trim(),
      };

      const res = await changeStudentMobileNumberAPI(params);
      if (res && res.IsSuccessful) {
        showSuccessToastMsg(
          res.Message || "Mobile number changed successfully"
        );
        setChangeMobileData({
          mobileNo: "",
          confirmMobileNo: "",
        });
      } else {
        showErrorToastMsg(res?.Message || "Failed to change mobile number");
      }
    } catch (error) {
      console.error("Error changing mobile number:", error);
      showErrorToastMsg("Failed to change mobile number");
    } finally {
      setChangingMobile(false);
    }
  };

  const handleChangeMobileChange = (e) => {
    const { name, value } = e.target;
    setChangeMobileData({
      ...changeMobileData,
      [name]: value,
    });
  };

  if (student === null) {
    return (
      <div className="bg-white rounded-lg shadow-md p-6 mb-6 border-l-4 border-primary-600"></div>
    );
  }

  return (
    <div>
      <h4 className="text-lg font-medium text-gray-900 mb-4">
        Change Mobile Number
      </h4>
      <form onSubmit={handleSubmitChangeMobile} className="max-w-md">
        <div className="mb-4">
          <div className="mb-4 p-3 bg-gray-50 rounded-md">
            <p className="text-sm text-gray-600">Current Mobile Number:</p>
            <p className="text-sm font-medium text-gray-900">
              {student?.MobileNo || ""}
            </p>
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              New Mobile Number <span className="text-red-500">*</span>
            </label>
            <input
              type="tel"
              name="mobileNo"
              value={changeMobileData.mobileNo}
              onChange={handleChangeMobileChange}
              placeholder="Enter new mobile number"
              className="text-sm font-medium w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              required
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Confirm Mobile Number <span className="text-red-500">*</span>
            </label>
            <input
              type="tel"
              name="confirmMobileNo"
              value={changeMobileData.confirmMobileNo}
              onChange={handleChangeMobileChange}
              placeholder="Confirm new mobile number"
              className="text-sm font-medium w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              required
            />
          </div>
        </div>

        <div className="flex justify-end space-x-3">
          <button
            type="button"
            onClick={() => {
              setChangeMobileData({
                mobileNo: "",
                confirmMobileNo: "",
              });
            }}
            disabled={changingMobile}
            className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400 disabled:opacity-50 font-medium"
          >
            Clear
          </button>
          <button
            type="submit"
            disabled={changingMobile}
            className="px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 disabled:opacity-50 font-medium"
          >
            {changingMobile ? "Changing..." : "Change Mobile Number"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default StudentContactNumberManage;
